/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type UnknownHexRowFragment = {
  readonly __typename: "UnknownHex";
  readonly id: c.HexId;
  readonly userUpdatedDate: c.DateTimeString;
  readonly hexType: Types.HexType;
  readonly creator: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly owner: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
};

export const UnknownHexRowFragmentDoc = /*#__PURE__*/ gql`
  fragment UnknownHexRowFragment on UnknownHex {
    id
    userUpdatedDate
    creator {
      id
      name
      email
    }
    owner {
      id
      name
      email
    }
    hexType
  }
`;
